// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/sections/Services.css */
.services {
  position: relative;
  padding: 100px 0;
  background: var(--dark-bg);
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-title {
  font-size: clamp(2rem, 4vw, 3rem);
  margin-bottom: 20px;
  background: var(--gradient-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-subtitle {
  font-size: 1.2rem;
  color: var(--text-secondary);
  max-width: 600px;
  margin: 0 auto;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
}

.service-card {
  position: relative;
  overflow: hidden;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.service-card:hover .service-hover-effect {
  opacity: 0.1;
  transform: scale(1);
}

.service-card:hover .service-icon {
  transform: rotateY(180deg);
}

.service-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  color: white;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  position: relative;
}

.service-icon::after {
  content: '';
  position: absolute;
  inset: -2px;
  border-radius: 20px;
  padding: 2px;
  background: inherit;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  opacity: 0.5;
}

.service-title {
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: var(--text-primary);
}

.service-description {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 20px;
}

.service-hover-effect {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
  transition: all 0.5s ease;
  pointer-events: none;
  filter: blur(40px);
}

/* Responsive */
@media (max-width: 768px) {
  .services-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .service-card {
    max-width: 400px;
    margin: 0 auto;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .section-subtitle {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sections/Services.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,8EAA8E;EAE9E,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,UAAU;EACV,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* src/components/sections/Services.css */\n.services {\n  position: relative;\n  padding: 100px 0;\n  background: var(--dark-bg);\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.section-title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  margin-bottom: 20px;\n  background: var(--gradient-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-subtitle {\n  font-size: 1.2rem;\n  color: var(--text-secondary);\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.services-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n}\n\n.service-card {\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.service-card:hover .service-hover-effect {\n  opacity: 0.1;\n  transform: scale(1);\n}\n\n.service-card:hover .service-icon {\n  transform: rotateY(180deg);\n}\n\n.service-icon {\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 25px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  color: white;\n  transition: transform 0.6s;\n  transform-style: preserve-3d;\n  position: relative;\n}\n\n.service-icon::after {\n  content: '';\n  position: absolute;\n  inset: -2px;\n  border-radius: 20px;\n  padding: 2px;\n  background: inherit;\n  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0.5;\n}\n\n.service-title {\n  font-size: 1.5rem;\n  margin-bottom: 15px;\n  color: var(--text-primary);\n}\n\n.service-description {\n  color: var(--text-secondary);\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n.service-hover-effect {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 300px;\n  height: 300px;\n  border-radius: 50%;\n  transform: translate(-50%, -50%) scale(0);\n  opacity: 0;\n  transition: all 0.5s ease;\n  pointer-events: none;\n  filter: blur(40px);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .services-grid {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .service-card {\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  .section-title {\n    font-size: 2rem;\n  }\n  \n  .section-subtitle {\n    font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
